// import { createContext, useState } from "react";

// export const MenuContext = createContext({
//   isMobile: false,
//   ispopUp: false,
//   scrollPosition: 0,
//   isauthDrop: false,
//   setIssAuthDrop: () => {},
// });

// export const  MenuProvider = ({ children }) => {
//   const [isMobile, setIsMobile] = useState(false);
//   const [ispopUp, setIspopUp] = useState(false);
//   const [scrollPosition, setScrollPosition] = useState(0);
//   const [isauthDrop, setIssAuthDrop] = useState(false);
//   const [tokens, setToken] = useState("000000");

//   const value = {
//     isMobile,
//     setIsMobile,
//     ispopUp,
//     setIspopUp,
//     scrollPosition,
//     setScrollPosition,
//     isauthDrop,
//     setIssAuthDrop,
//     tokens, setToken
//   };

//   return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
// };


import { createContext, useState } from "react";

export const MenuContext = createContext({
  isMobile: false,
  ispopUp: false,
  scrollPosition: 0,
  isauthDrop: false,
  setIssAuthDrop: () => {},
  serviceDrop: false,
  setServiceDrop: () => {},
  tokens: "",
  setToken: () => {}
});

export const MenuProvider = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [ispopUp, setIspopUp] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isauthDrop, setIssAuthDrop] = useState(false);
  const [serviceDrop, setServiceDrop] = useState(false);
  const [tokens, setToken] = useState("000000");

  const value = {
    isMobile,
    setIsMobile,
    ispopUp,
    setIspopUp,
    scrollPosition,
    setScrollPosition,
    isauthDrop,
    setIssAuthDrop,
    serviceDrop,
    setServiceDrop,
    tokens, 
    setToken
  };

  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
};
